import React from 'react';
import { useTranslation } from '@shared/core';
import { Box, IconV2, TextV2, TooltipV2 } from '@withjoy/joykit';
import { Info } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';

export const Tooltip = () => {
  const { t } = useTranslation('sharedComponents');
  const { toolTip } = t('registryGiftCounts');
  return (
    <TooltipV2
      placement="topStart"
      content={
        <Box maxWidth={pxToRem(256)}>
          <TextV2 color="white" typographyVariant="label2">
            {toolTip()}
          </TextV2>
        </Box>
      }
    >
      <IconV2 size="sm" color="mono10">
        <Info />
      </IconV2>
    </TooltipV2>
  );
};
